import React from "react";

const ASP_Intro = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Intro</h1>
      <p>This is the ASP Intro page content.</p>
    </div>
  );
};

export default ASP_Intro;
